export function validatePassword(x: string): boolean {
  const MIN_LENGTH = 8;
  const MAX_LENGTH = 50;

  if (typeof x == "undefined") return false;

  const meetsLengthRequirements = x.length >= MIN_LENGTH && x.length <= MAX_LENGTH;
  let hasLetter = false;
  let hasNumber = false;
  let hasSpecialDigit = false;

  if (meetsLengthRequirements) {
    const chars = x.split("");

    chars.forEach((c: string) => {
      if (c.toLowerCase() != c.toUpperCase()) hasLetter = true;
      else if (c >= "0" && c <= "9") hasNumber = true;
      else hasSpecialDigit = true;
    });
  }

  // eslint-disable-next-line
  const isValid = meetsLengthRequirements && hasLetter && hasNumber && hasSpecialDigit;

  return isValid;
}
